import { render, staticRenderFns } from "./moduleDetail.vue?vue&type=template&id=89d34086&scoped=true"
import script from "./moduleDetail.vue?vue&type=script&lang=js"
export * from "./moduleDetail.vue?vue&type=script&lang=js"
import style0 from "./moduleDetail.vue?vue&type=style&index=0&id=89d34086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d34086",
  null
  
)

export default component.exports